import { render, staticRenderFns } from "./dashboard.vue?vue&type=template&id=70e5e42e&scoped=true&"
import script from "./dashboard.vue?vue&type=script&lang=ts&"
export * from "./dashboard.vue?vue&type=script&lang=ts&"
import style0 from "./dashboard.vue?vue&type=style&index=0&id=70e5e42e&prod&lang=scss&scoped=true&"
import style1 from "./dashboard.vue?vue&type=style&index=1&id=70e5e42e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e5e42e",
  null
  
)

export default component.exports